// deps
import React from "react";

// types
import { PaymentGroupHandlerProps } from "../interfaces";
import { RewardsPaymentGroup } from "@swiggy-private/payment-ui";

// components
import { Rewards } from "@swiggy-private/payment-ui";

// hooks
import { usePaymentActions } from "../hooks/UsePaymentActions";
import useFlipkartCoins from "@payment-client/hooks/useFlipkartCoins";

export interface RewardsGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: RewardsPaymentGroup["paymentData"];
}

export function RewardsGroupHandler(props: RewardsGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const paymentActions = usePaymentActions({ onSelect, onPay });

    // FK coins will come under rewards with twid rollout
    const onFlipkartToolTipShow = useFlipkartCoins(true);

    return (
        <Rewards
            paymentActions={paymentActions}
            paymentData={props.paymentGroup}
            onFlipkartToolTipShow={onFlipkartToolTipShow}
            {...otherProps}
        />
    );
}
